import { MetricPipe } from './metric.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [MetricPipe],
  providers: [MetricPipe],
  exports: [MetricPipe]
})
export class MetricPipeModule { }
